import React from 'react';
import { Alert, Button, Box } from '@mui/material';
import { Publish as PublishIcon } from '@mui/icons-material';

interface SurveyDraftBannerProps {
  onPublish: () => void;
  isLoading?: boolean;
}

export const SurveyDraftBanner: React.FC<SurveyDraftBannerProps> = ({
  onPublish,
  isLoading = false,
}) => {
  return (
    <Alert
      severity="info"
      sx={{
        display: 'flex',
        alignItems: 'center',
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          py: 0,
        },
      }}
    >
      <Box sx={{ flex: 1 }}>
        This survey is in draft mode. You must publish it before it can be shared with students.
      </Box>
      <Box sx={{ ml: 'auto' }}>
        <Button
          variant="contained"
          color="success"
          startIcon={<PublishIcon />}
          onClick={onPublish}
          disabled={isLoading}
          size="small"
        >
          Publish
        </Button>
      </Box>
    </Alert>
  );
};
